const UserNotificationApp = () => import(/* webpackChunkName: "UserNotificationApp" */ './containers/UserNotificationApp');
const UserNotificationList = () => import(/* webpackChunkName: "UserNotificationList" */ './components/UserNotificationList');
const UserNotificationCreate = () => import(/* webpackChunkName: "UserNotificationCreate" */ './components/UserNotificationCreate');

export const userNotificationRouting = [
    {
        path: 'user-notification', name: 'user-notification', component: UserNotificationApp,
        children: [
            { path: '/', redirect: 'user-notification-list' },
            { path: 'user-notification-list', name: 'user-notification-list', component: UserNotificationList },
            { path: 'user-notification-create', name: 'user-notification-create', component: UserNotificationCreate },
        ]
    }
]